import { Subject } from "rxjs";

import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { IClientActionService } from "../IClientActionService";
import { CubiqWorker } from "../../worker/CubiqWorker";
import { ServiceMessageBroker, ServiceMessageBrokerFactory } from "shared/provider-webworker";
import { NotificationMethod } from "shared/cubiq-model-multi-asset";

export abstract class ClientActionPromiseService implements IClientActionService {
  abstract updateClientComments(
    clientCode: string,
    clientComment: string,
    privateComment: string,
  ): Promise<void>;
  abstract saveClientContact(
    id: string,
    clientCd: string,
    contactName: string,
    desk: string,
    mobile: string,
    sms: string,
    email: string,
    isDefault: boolean,
    notifyEntry: NotificationMethod,
    notifyExpiry: NotificationMethod,
    notifyFill: NotificationMethod,
    notifyModify: NotificationMethod,
    notifyCancel: NotificationMethod,
  ): Promise<void>;
  abstract deleteClientContact(clientContactId: string): Promise<void>;
  abstract saveClientTrader(
    clientCode: string,
    comment: string,
    userName: string,
    userCode: string,
    desk: string,
    mobile: string,
    email: string,
    isDefault: boolean,
  ): Promise<void>;
  abstract deleteClientTrader(clientCode: string, userName: string): Promise<void>;
}
